type MarkerStore = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>

/** Persist before dispatch: reloads and other tabs must not replay an uncertain rotation. */
export class RefreshAttemptGuard {
  private marker: string | null = null

  constructor(
    private key: string,
    private storage?: MarkerStore
  ) {}

  isBlocked(fingerprint: string): boolean {
    try {
      if (this.storage) this.marker = this.storage.getItem(this.key)
    } catch {
      // In-memory protection remains available when browser storage is disabled.
    }
    return this.marker === fingerprint
  }

  begin(fingerprint: string) {
    this.marker = fingerprint
    try {
      this.storage?.setItem(this.key, fingerprint)
    } catch {}
  }

  confirm() {
    this.marker = null
    try {
      this.storage?.removeItem(this.key)
    } catch {}
  }
}
